import { render } from "./AddTransactionView.vue?vue&type=template&id=7221d8fe&scoped=true&lang=pug"
import script from "./AddTransactionView.js?vue&type=script&lang=js"
export * from "./AddTransactionView.js?vue&type=script&lang=js"

import "./AddTransactionView.scss?vue&type=style&index=0&id=7221d8fe&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7221d8fe"]])

export default __exports__